// extracted by mini-css-extract-plugin
export default {"menuDiv":"MenuItems_menuDiv__+hIBj","open":"MenuItems_open__0CBjv","ul":"MenuItems_ul__7NwLE","homeLi":"MenuItems_homeLi__KxOKE"};